import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

require('bootstrap-maxlength');
require('tempusdominus-bootstrap-4');
require('daterangepicker');
require('bootstrap-timepicker');

import { DatePicker } from 'antd';
import 'antd/dist/reset.css';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/l10n/vn.js';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import Inputmask from 'inputmask';
import CurrencyInput from 'react-currency-input-field';
import { useTranslation } from 'react-i18next';

dayjs.locale('vi');

export const KTFormInputType = {
  text: 'text',
  search: 'search',
  email: 'email',
  url: 'url',
  telephone: 'tel',
  password: 'password',
  customPassword: 'custom-password',
  number: 'number',
  datetime: 'datetime-local',
  date: 'date',
  month: 'month',
  year: 'year',
  week: 'week',
  time: 'time',
  color: 'color',
  range: 'range',
  currency: 'currency',

  btdPicker: 'btd-picker', // date time picker
  dateRangePicker: 'date-range-picker', // date range picker
  bsDatePicker: 'bs-date-picker', // bootstrap date picker
  bsTimePicker: 'bs-time-picker', // bootstrap time picker
};

export const KTFormInputSize = {
  default: '',
  large: 'form-control-lg',
  small: 'form-control-sm',
};

export const KTFormInputIconPosition = {
  left: 'input-icon-left',
  right: 'input-icon-right',
};

export const KTFormInputGroupType = {
  text: 'text',
  button: 'button',
};

export const KTFormInputBTDPickerType = {
  dateTime: 'date-time',
  date: 'date',
  time: 'time',
  dateRange: 'date-range',
};

KTFormInput.propTypes = {
  // required
  type: PropTypes.oneOf(Object.values(KTFormInputType)).isRequired,
  name: PropTypes.string.isRequired,

  // optional
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  solidBackground: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(KTFormInputSize)),
  isCustom: PropTypes.bool,
  additionalInputClassName: PropTypes.string,
  additionalClassName: PropTypes.string,

  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onCompositionStart: PropTypes.func,
  onCompositionEnd: PropTypes.func,
  enableCheckValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  feedbackText: PropTypes.string,
  isCopy: PropTypes.bool,

  // max length
  maxLength: PropTypes.number,
  maxLengthWarningClass: PropTypes.string,
  maxLengthReachedClass: PropTypes.string,
  maxLengthCustomSeparator: PropTypes.string,
  maxLengthCustomPreText: PropTypes.string,
  maxLengthCustomPostText: PropTypes.string,

  enableInputGroup: PropTypes.bool,
  inputGroupType: PropTypes.oneOf(Object.values(KTFormInputGroupType)),
  prependElements: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  appendElements: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  inputGroupAdditionalClassName: PropTypes.string,

  enableInputIcon: PropTypes.bool,
  inputIconPosition: PropTypes.oneOf(Object.values(KTFormInputIconPosition)),
  inputIconElement: PropTypes.element,

  // btd-picker
  btdPickerType: PropTypes.oneOf(Object.values(KTFormInputBTDPickerType)),
  btdPickerNoIcon: PropTypes.bool,
  btdPickerLocale: PropTypes.string,
  btdDisabledDates: PropTypes.arrayOf(PropTypes.string),

  // date-range-picker
  drpAutoUpdateInput: PropTypes.bool,
  drpEnableTimePicker: PropTypes.bool,
  drpSingleDatePicker: PropTypes.bool,
  drpEnablePredefinedRange: PropTypes.bool,

  // bootstrap time picker
  bsTimePicker24hMode: PropTypes.bool,
  bsTimePickerMinuteStep: PropTypes.number,
  bsTimePickerShowSecond: PropTypes.bool,
  bsTimePickerSecondStep: PropTypes.number,

  // input mask
  enableInputMask: PropTypes.bool,
  inputMaskString: PropTypes.string,
  maskInputFormat: PropTypes.string,
  inputMaskAdditionalOptions: PropTypes.object,

  // max time
  maxTime: PropTypes.string,
  minTime: PropTypes.string,

  //value limit
  maxValue: PropTypes.number,
  minValue: PropTypes.number,

  // unit
  unit: PropTypes.string,
  showUnit: PropTypes.bool,

  checkValidInput: PropTypes.function,
};

KTFormInput.defaultProps = {
  value: '',
  placeholder: '',
  text: '',
  solidBackground: false,
  disabled: false,
  readonly: false,
  size: KTFormInputSize.default,
  isCustom: true,
  additionalInputClassName: '',
  additionalClassName: '',

  onChange: null,
  onClick: null,
  onBlur: null,
  onFocus: null,
  onCompositionStart: null,
  onCompositionEnd: null,
  enableCheckValid: false,
  isValid: true,
  isTouched: false,
  feedbackText: '',
  isCopy: false,

  // max length
  maxLength: 0,
  maxLengthWarningClass: 'label label-danger label-rounded label-inline',
  maxLengthReachedClass: 'label label-primary label-rounded label-inline',
  maxLengthCustomSeparator: '/',
  maxLengthCustomPreText: '',
  maxLengthCustomPostText: '',

  enableInputGroup: false,
  inputGroupType: KTFormInputGroupType.text,
  prependElements: null,
  appendElements: null,
  inputGroupAdditionalClassName: '',

  enableInputIcon: false,
  inputIconPosition: KTFormInputIconPosition.left,
  inputIconElement: null,

  // btd-picker
  btdPickerType: null,
  btdPickerNoIcon: false,
  btdPickerLocale: 'en',
  btdDisabledDates: null,

  // date-range-picker
  drpAutoUpdateInput: true,
  drpEnableTimePicker: false,
  drpSingleDatePicker: false,
  drpEnablePredefinedRange: false,

  // bootstrap time picker
  bsTimePicker24hMode: false,
  bsTimePickerMinuteStep: 1,
  bsTimePickerShowSecond: false,
  bsTimePickerSecondStep: 1,

  // input mask
  enableInputMask: false,
  inputMaskString: '',
  maskInputFormat: '',
  inputMaskAdditionalOptions: {},

  //max time
  maxTime: '9999-12-31T00:00',

  //value limit
  minValue: 0,

  unit: '',
  showUnit: true,

  checkValidInput: null,
};

/**
 *
 * @param {{
 * type: string,
 * name: string,
 * value: string,
 * placeholder: string,
 * text: string | element,
 * solidBackground: boolean,
 * disabled: boolean,
 * readonly: boolean,
 * size: string,
 * isCustom: boolean,
 * additionalInputClassName: string,
 * additionalClassName: string,
 * onChange: function,
 * onClick: function,
 * onBlur: function,
 * onFocus: function,
 * enableCheckValid: boolean,
 * isValid: boolean,
 * isTouched: boolean,
 * isCopy: boolean,
 * feedbackText: string,
 * maxLength: number,
 * maxLengthWarningClass: string,
 * maxLengthReachedClass: string,
 * maxLengthCustomSeparator: string,
 * maxLengthCustomPreText: string,
 * maxLengthCustomPostText: string,
 * enableInputGroup: boolean,
 * inputGroupType: string,
 * prependElements: [],
 * appendElements: [],
 * inputGroupAdditionalClassName: string,
 * enableInputIcon,
 * inputIconPosition,
 * inputIconElement: element,
 * btdPickerType: string?,
 * btdPickerNoIcon: boolean,
 * btdPickerLocale: string,
 * btdDisabledDates: string[],
 * drpAutoUpdateInput: boolean,
 * drpEnableTimePicker: boolean,
 * drpSingleDatePicker: boolean,
 * drpEnablePredefinedRange: boolean,
 *
 * bsTimePicker24hMode: boolean,
 * bsTimePickerMinuteStep: number,
 * bsTimePickerShowSecond: boolean,
 * bsTimePickerSecondStep: number,
 *
 * enableInputMask: boolean,
 * inputMaskString: string,
 * maskInputFormat: string,
 * inputMaskAdditionalOptions: object,
 *
 * maxTime: datetime,
 * minTime: datetime
 * 
 * maxValue: number,
 * minValue: number,
 *
 * unit: string,
 * showUnit: boolean,
 * 
 * checkValidInput: function,
 * }} props
 * @returns
 */
function KTFormInput(props) {
  // MARK: --- Params ---
  const {
    type,
    name,

    value,
    placeholder,
    text,
    solidBackground,
    disabled,
    readonly,
    size,
    isCustom,
    additionalInputClassName,
    additionalClassName,
    onChange,
    onClick,
    onBlur,
    onFocus,
    onCompositionStart,
    onCompositionEnd,
    enableCheckValid,
    isValid,
    isTouched,
    feedbackText,
    isCopy,

    // max length
    maxLength,
    maxLengthWarningClass,
    maxLengthReachedClass,
    maxLengthCustomSeparator,
    maxLengthCustomPreText,
    maxLengthCustomPostText,

    enableInputGroup,
    inputGroupType,
    prependElements,
    appendElements,
    inputGroupAdditionalClassName,

    enableInputIcon,
    inputIconPosition,
    inputIconElement,

    // btd-picker
    btdPickerType,
    btdPickerNoIcon,
    btdPickerLocale,
    btdDisabledDates,

    // date-range-picker
    drpAutoUpdateInput,
    drpEnableTimePicker,
    drpSingleDatePicker,
    drpEnablePredefinedRange,

    // bootstrap time picker
    bsTimePicker24hMode,
    bsTimePickerMinuteStep,
    bsTimePickerShowSecond,
    bsTimePickerSecondStep,

    // input mask
    enableInputMask,
    inputMaskString,
    maskInputFormat,
    inputMaskAdditionalOptions,

    //max time
    maxTime,
    minTime,

    //value limit
    maxValue,
    minValue,

    unit = 'VND',
    showUnit = true,

    checkValidInput,
    additionalButton = null,
    placement = 'bottomLeft', //bottomLeft || topLeft
  } = props;

  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState(value);
  const [passwordEyeOn, setPasswordEyeOn] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedDate, setSelectedDate] = useState(value ? dayjs(value) : null);
  useEffect(() => {
    setSelectedDate(value ? dayjs(value) : null);
  }, [value]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (type === 'date') {
      const isoDate = date ? date.format('YYYY-MM-DD') : '';
      onChange(isoDate);
    } else if (type === 'month') {
      const isoMonth = date ? date.format('YYYY-MM') : '';
      onChange(isoMonth);
    } else if (type === 'year') {
      const isoYear = date ? date.format('YYYY') : '';
      onChange(isoYear);
    } else if (type === KTFormInputType.datetime) {
      const isoDateTime = date ? date.format('YYYY-MM-DD HH:mm') : '';
      onChange(isoDateTime);
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // MARK: --- Functions ---
  function handleChange(e) {
    if (type === KTFormInputType.currency) {
      const numberValue = e ? Number(e.replace(/\./g, '').replace(',', '.')) : 0;

      setInputValue(e);

      if (onChange) {
        onChange(numberValue);
      }
    } else {
      const targetValue = e?.target?.value;

      const parsedValue =
        type === KTFormInputType.number
          ? targetValue === ''
            ? ''
            : Number(targetValue)
          : targetValue;

      if (!checkValidInput || (checkValidInput && checkValidInput(parsedValue))) {
        setInputValue(targetValue);

        if (onChange) {
          onChange(parsedValue);
        }
      }
    }
  }
  function handleClick() {
    if (onClick) {
      onClick();
    }
  }
  function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  }
  function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  }

  // MARK: --- Hooks ---
  useEffect(() => {
    // maxlength
    if (maxLength > 0) {
      $(`#${name}`).maxlength({
        warningClass: maxLengthWarningClass,
        limitReachedClass: maxLengthReachedClass,
        separator: maxLengthCustomSeparator,
        preText: maxLengthCustomPreText,
        postText: maxLengthCustomPostText,
      });
    }

    // btd-picker
    if (type === KTFormInputType.btdPicker) {
      const options = {
        // custom icon
        icons: {
          time: 'ki ki-clock',
          date: 'ki ki-calendar',
        },
        // locale
        locale: btdPickerLocale,
        // default date
        defaultDate: inputValue,
      };
      if (btdPickerType === KTFormInputBTDPickerType.dateTime) {
        options.format = 'DD/MM/YYYY - HH:mm';
      }
      if (btdPickerType === KTFormInputBTDPickerType.date) {
        options.format = 'DD/MM/YYYY';
      }
      if (btdPickerType === KTFormInputBTDPickerType.time) {
        options.format = 'HH:mm';
      }
      if (btdDisabledDates) {
        options.disabledDates = btdDisabledDates;
      }
      $(`#${name}`).datetimepicker(options);
    }

    // date range picker
    if (type === KTFormInputType.dateRangePicker) {
      const options = {
        buttonClasses: 'btn',
        applyClass: 'btn-primary',
        cancelClass: 'btn-secondary',

        opens: 'right',
        autoUpdateInput: drpAutoUpdateInput,
        timePicker: drpEnableTimePicker,
        singleDatePicker: drpSingleDatePicker,
      };
      if (drpEnablePredefinedRange) {
        options.ranges = {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
        };
      }

      $(`#${name}`).daterangepicker(options, function (start, end, label) {
        setInputValue(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
      });
    }

    // bootstrap time picker
    if (type === KTFormInputType.bsTimePicker) {
      const options = {
        icons: {
          up: 'ki ki-arrow-up',
          down: 'ki ki-arrow-down',
        },
        showMeridian: bsTimePicker24hMode ? false : true,
        minuteStep: bsTimePickerMinuteStep,
        showSeconds: bsTimePickerShowSecond,
        secondStep: bsTimePickerSecondStep,
      };
      $(`#${name}`).timepicker(options);

      $(`#${name}`).on('hide.timepicker', function (e) {
        const timeValue = e?.time?.value;
      });
      $(`#${name}`).on('changeTime.timepicker', function (e) { });
    }

    // input mask
    if (enableInputMask) {
      const selector = document.getElementById(name);
      const options = {
        showMaskOnFocus: false,
      };
      if (!_.isEmpty(placeholder)) {
        options.placeholder = placeholder;
      }
      if (!_.isEmpty(maskInputFormat)) {
        options.inputFormat = maskInputFormat;
      }
      Inputmask(inputMaskString, {
        ...options,
        ...inputMaskAdditionalOptions,
      }).mask(selector);
    }

    return () => { };
  }, [type]);

  return (
    <div className={`${additionalClassName} w-100`}>
      <div
        className={`position-relative d-flex
                    ${type === KTFormInputType.btdPicker
            ? `input-group ${solidBackground ? 'input-group-solid' : ''}`
            : enableInputIcon
              ? `input-icon ${inputIconPosition}`
              : ''
          }
                `}
      >
        {enableInputGroup &&
          prependElements &&
          prependElements.map((item, index) => {
            return (
              <div key={index} className="input-group-prepend">
                {inputGroupType === KTFormInputGroupType.text && (
                  <span
                    className={`input-group-text ${inputGroupAdditionalClassName}`}
                    style={{ color: AppColors.gray[800] }}
                  >
                    {' '}
                    {item}
                  </span>
                )}
                {inputGroupType === KTFormInputGroupType.button && item}
              </div>
            );
          })}

        <div
          className="position-relative w-100"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {type !== KTFormInputType.currency &&
            type !== KTFormInputType.date &&
            type !== KTFormInputType.month &&
            type !== KTFormInputType.year &&
            type !== KTFormInputType.datetime ? (
            <div className="d-flex flex-grow-1">
              <input
                className={`
                        form-control mt-0
                        ${additionalInputClassName}
                        ${!isValid ? 'invalid-feedback' : ''}
                        ${solidBackground ? 'form-control-solid' : ''}
                        ${size}
                        ${type === KTFormInputType.range && isCustom ? 'custom-range border-0' : ''}
                        ${type === KTFormInputType.btdPicker ? 'datetimepicker-input' : ''}
                        ${type === KTFormInputType.password ||
                    type === KTFormInputType.customPassword
                    ? 'form-control-iconless'
                    : ''
                  }
                        ${enableCheckValid && isTouched
                    ? `${isValid ? 'is-valid*' : 'is-invalid'}`
                    : ''
                  }
                   ${type === KTFormInputType.customPassword && !passwordEyeOn
                    ? 'password-masked'
                    : ''
                  }
                    `}
                style={{
                  appearance: type === KTFormInputType.range && !isCustom ? 'auto' : '',
                }}
                type={
                  (type === KTFormInputType.password || type === KTFormInputType.customPassword) &&
                    passwordEyeOn
                    ? 'text'
                    : type
                }
                name={name}
                id={name}
                value={inputValue}
                placeholder={placeholder}
                disabled={disabled}
                readOnly={readonly}
                maxLength={maxLength > 0 ? `${maxLength}` : ''}
                max={
                  maxTime
                    ? type === 'datetime-local'
                      ? maxTime.slice(0, 16)
                      : maxTime.slice(0, 10)
                    : type === KTFormInputType.number ? maxValue : undefined
                }
                min={
                  minTime
                    ? type === 'datetime-local'
                      ? minTime.slice(0, 16)
                      : minTime.slice(0, 10)
                    : type === KTFormInputType.number ? minValue : undefined
                }
                data-toggle={
                  type === KTFormInputType.btdPicker && btdPickerNoIcon ? 'datetimepicker' : ''
                }
                autoComplete={'off'}
                onChange={handleChange}
                onClick={handleClick}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onCompositionStart={onCompositionStart || undefined}
                onCompositionEnd={onCompositionEnd || undefined}
                onInput={() => { }}
                title=""
                onInvalid={(e) => e.preventDefault()}
              />
              {isCopy && (
                <div className="position-absolute right-0 pt-4 pr-4">
                  <i
                    className="fa-regular fa-copy cursor-pointer"
                    style={{ width: 16, height: 18, color: AppColors.gray[800] }}
                    onClick={() => {
                      Utils.copyTextToClipboard(value, () => {
                        ToastHelper.showSuccess(t('copied'));
                      });
                    }}
                  />
                </div>
              )}
              {showUnit && unit && (
                <div className="unit position-absolute right-0 px-3 h-100 font-weight-bold rounded-right d-flex align-items-center justify-content-center">
                  <span>{unit}</span>
                </div>
              )}
            </div>
          ) : type === KTFormInputType.date || type === KTFormInputType.month || type === KTFormInputType.year || type === KTFormInputType.datetime ? (
            <DatePicker
              id={name}
              value={selectedDate}
              onChange={handleDateChange}
              picker={type === KTFormInputType.datetime ? 'date' : type}
              showTime={type === KTFormInputType.datetime}
              format={type === KTFormInputType.year ? 'YYYY' : type === KTFormInputType.month ? 'MM/YYYY' : type === KTFormInputType.datetime ? 'DD/MM/YYYY - HH:mm' : 'DD/MM/YYYY'}
              minDate={minTime ? dayjs(minTime) : null}
              maxDate={maxTime ? dayjs(maxTime) : null}
              placeholder={placeholder || (type === KTFormInputType.datetime ? 'Chọn ngày giờ' : 'Chọn ngày')}
              suffixIcon={<i className="fa-solid fa-calendar-days" />}
              locale={viVN}
              disabled={disabled}
              placement={placement}
              className={`
      form-control mt-0 form-control-iconless
      ${additionalInputClassName}
      ${!isValid ? 'invalid-feedback' : ''}
      ${enableCheckValid && isTouched ? `${isValid ? 'is-valid' : 'is-invalid'}` : ''}
    `}
            />
          ) : (
            <div className="d-flex flex-grow-1 w-100">
              <CurrencyInput
                name={name}
                value={inputValue}
                placeholder={placeholder}
                className={`
              form-control mt-0
              ${additionalInputClassName}
              ${!isValid ? 'invalid-feedback' : ''}
              ${enableCheckValid && isTouched ? `${isValid ? 'is-valid*' : 'is-invalid'}` : ''}
            `}
                decimalSeparator=","
                groupSeparator="."
                defaultValue={0}
                decimalsLimit={2}
                onValueChange={handleChange}
                disabled={disabled}
                allowNegativeValue={false}
              />
              {!prependElements && showUnit ? (
                <div
                  className="unit position-absolute right-0 p-3 font-weight-bold rounded-right h-100 min-w-40px text-center"
                  style={{ backgroundColor: AppColors.gray[200] }}
                >
                  {unit ? unit : 'VNĐ'}
                </div>
              ) : (
                <></>
              )}
            </div>
          )}

          {enableCheckValid && isTouched && feedbackText && showTooltip && (
            <div
              className="position-absolute error-tooltip rounded p-3"
              style={{
                top: -42,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10,
                backgroundColor: '#fff',
                color: AppColors.gray[700],
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                fontWeight: '500',
              }}
            >
              {feedbackText}
              <div
                style={{
                  position: 'absolute',
                  bottom: '-6px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '6px solid transparent',
                  borderRight: '6px solid transparent',
                  borderTop: '6px solid #fff',
                }}
              />
            </div>
          )}

          {additionalButton && (
            <div
              className="position-absolute error-tooltip rounded p-3"
              style={{
                top: -5,
                right: -5,
                left: 'auto',
                transform: 'translateX(0)',
                zIndex: 10,
                color: AppColors.gray[700],
                fontSize: '14px',
                whiteSpace: 'nowrap',
                fontWeight: '500',
                maxWidth: 'calc(100% - 16px)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {additionalButton}
            </div>
          )}
        </div>

        {/* password eye on/off */}
        {(type === KTFormInputType.password || type === KTFormInputType.customPassword) && (
          <div
            className="position-absolute h-100 right-0 top-0 d-flex align-items-center px-4 cursor-pointer hover-opacity-60"
            onClick={() => {
              setPasswordEyeOn(!passwordEyeOn);
            }}
          >
            <i className={passwordEyeOn ? 'fas fa-eye-slash' : 'fas fa-eye'} />
          </div>
        )}
        {/* input group */}
        {type === KTFormInputType.btdPicker && !btdPickerNoIcon && (
          <div
            className="input-group-append"
            data-toggle={
              type === KTFormInputType.btdPicker && !btdPickerNoIcon ? 'datetimepicker' : ''
            }
            data-target={type === KTFormInputType.btdPicker && !btdPickerNoIcon ? `#${name}` : ''}
          >
            <span className="input-group-text">
              <i
                className={`ki ki-${btdPickerType === KTFormInputBTDPickerType.time ? 'clock' : 'calendar'
                  }`}
              />
            </span>
          </div>
        )}
        {type !== KTFormInputType.btdPicker &&
          enableInputGroup &&
          appendElements &&
          appendElements.map((item, index) => {
            return (
              <div key={index} className="input-group-append">
                {inputGroupType === KTFormInputGroupType.text && (
                  <span className="input-group-text">{item}</span>
                )}
                {inputGroupType === KTFormInputGroupType.button && item}
              </div>
            );
          })}

        {/* input icon */}
        {enableInputIcon && inputIconElement && <span>{inputIconElement}</span>}
      </div>
      {!_.isEmpty(text) && <span className="form-text text-muted">{text}</span>}
    </div>
  );
}

export default KTFormInput;
